import type { AnalysesPlaceItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesDistricts.types'

export function buildAnalysesLpuCardsBaseUrl(townTranslit: string): string {
  return `/${townTranslit}/diagnostika/analiz/`
}

export function buildAnalysesPlaceFilterUrl(
  townTranslit: string,
  place: AnalysesPlaceItem,
): string {
  const placePrefix = place.isMetro ? 'metro' : 'd'

  return `${buildAnalysesLpuCardsBaseUrl(townTranslit)}${placePrefix}-${place.translit}/`
}
